import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const AddQA = ({list}) => {
    const [channels, setChannels] = useState([]);
    const [clients, setClients] = useState([]);
    const [projects, setProjects] = useState([]);
    const [taskIncharge, setTaskIncharge] = useState([]);
    const [assignedTester, setAssignedTester] = useState([]);
    const [getstatus, setStatus] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState('');
    const [selectedClient, setSelectedClient] = useState('');

    const schema = Yup.object().shape({
        project_id: Yup.string().required('project is a required field'),
        task_incharge_id: Yup.string().required('manager/teamlead  is a required field'),
        assigned_tester_id: Yup.string().required('assign tester is a required field'),
        description: Yup.string().required(),
        browsers: Yup.array().nullable().typeError('please select at least one browser')
                    .min(1, 'please select at least one browser').required()
    });
    
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            if (key === 'attachment') {
                Array.from(data[key]).forEach((file, index) => {
                    formData.append(`${key}[${index}]`, file);
                });
            }
            else {
                formData.append(key, data[key]);
            }
        });

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/qa`, formData)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                reset();
                closeModal("add_qa");
                list();
            })
            .catch(error => {
                Swal.fire({text:error, icon:"error"});
                console.error('Error creating qa', error);
            });
    }

    const fetchData = async () => {
        try {
            const channelRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/channels`);
            setChannels(channelRes.data.data);

            const clientRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/clients`);
            setClients(clientRes.data.data);

            const projectRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/projects`);
            setProjects(projectRes.data.data);

            const teamleadsRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=teamleads`);
            setTaskIncharge(teamleadsRes.data.data);

            const testerRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=all`);
            setAssignedTester(testerRes.data.data);

            const qaStatusRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/qa_status`);
            setStatus(qaStatusRes.data.data);

        } catch (error) {
            console.error("Error fetching data!", error);
            setChannels([]); setClients([]); setProjects([]); setTaskIncharge([]); setAssignedTester([]); setStatus([]);
        }
    };

    useEffect(() => {
        fetchData();

        const modalElement = document.getElementById('add_qa');

        const handleClose = () => reset();

        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleClose);
        }
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleClose);
            }
        };
    }, [reset]);


    // Filter clients based on selected channel
    const filteredClients = selectedChannel 
        ? clients.filter(client => parseInt(client.channel_id) === parseInt(selectedChannel)) 
        : [];

    // Filter projects based on selected client
    const filteredProjects = selectedClient 
        ? projects.filter(project => parseInt(project.client_id) === parseInt(selectedClient)) 
        : [];

    return (
        <div id="add_qa" className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add QA</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel <span className="text-danger">*</span></label>
                                        <select className="form-control" value={selectedChannel}
                                            onChange={(event) => {setSelectedChannel(event.target.value); 
                                                                    setSelectedClient('');
                                                                }}>
                                                <option value="">Select Channel</option>
                                                {channels.map(row => (
                                                    <option key={row.id} value={row.id}>{row.name}</option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Client <span className="text-danger">*</span></label>
                                        <select className="form-control" value={selectedClient}
                                            onChange={(event) => {setSelectedClient(event.target.value); }}>
                                                <option value="">Select Client</option>
                                                {filteredClients.map(row => (
                                                    <option key={row.id} value={row.id}>{row.name}</option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Project <span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('project_id')}>
                                            <option value="">Select Project</option>
                                            {filteredProjects.map(project => (
                                                <option key={project.id} value={project.id}>{project.title}</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.project_id && <p>{errors.project_id.message}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Select Manager/Team Lead <span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('task_incharge_id')}>
                                            <option value="">Select Manager/Team Lead</option>
                                            {taskIncharge.map(incharge => (
                                                <option key={incharge.id} value={incharge.id}>{incharge.name} ({incharge.designation})</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.task_incharge_id && <p>{errors.task_incharge_id.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Assign Tester <span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('assigned_tester_id')}>
                                            <option value="">Select Assign Tester</option>
                                            {assignedTester.filter(tester => tester.department === 'Testing').map(tester => (
                                                <option key={tester.id} value={tester.id}>{tester.name}</option>
                                            ))}
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.assigned_tester_id && <p>{errors.assigned_tester_id.message}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Description <span className="text-danger">*</span></label>
                                        <textarea className="form-control" {...register('description')}  rows={3}></textarea>
                                        <div className="text-sm text-danger">
                                            {errors.description && <p>{errors.description.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Attachment </label>
                                        <input className="form-control" type="file" {...register('attachment')} multiple/>                                        
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Status </label>
                                        <select className="form-control" {...register('status')}>
                                            {getstatus.map(status => (
                                                <option key={status.id} value={status.id}>{status.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Browsers <span className="text-danger">*</span></label>
                                        <div className="checkbox">
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="Firefox" {...register('browsers')}/> Firefox
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="Chrome" {...register('browsers')}/> Chrome
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="IE" {...register('browsers')}/> IE
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="Safari" {...register('browsers')}/> Safari
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="Edge" {...register('browsers')}/> Edge
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="Responsive" {...register('browsers')}/> Responsive
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="Android" {...register('browsers')}/> Android
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="IOS" {...register('browsers')}/> IOS
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="Android tablet" {...register('browsers')}/> Android tablet
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="checkbox" value="Ipad" {...register('browsers')}/> Ipad
                                            </label>
                                        </div>

                                        <div className="text-sm text-danger">
                                            {errors.browsers && <p>{errors.browsers.message}</p>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddQA